/**
 * finaleChapterSelect — pure availability check for the Finale Chapter Select
 * replay driver (MY-1988).
 *
 * Unlocked after the player's first full campaign clear (highestStageCleared
 * reaches the final stage). Lets completionists jump straight to Phase 4
 * (the PM decision) without replaying all prior stages.
 *
 * No Phaser import — fully testable in Node.
 */

import type { SaveSlotData } from '@/systems/SaveManager';

/** Final campaign stage index — mirrors GameState.FINAL_STAGE. */
export const FINALE_STAGE = 9;

/**
 * Returns true when the player has cleared the final stage at least once,
 * unlocking the Finale Chapter Select.
 */
export function isFinaleChapterSelectAvailable(save: SaveSlotData | null): boolean {
  if (save === null) return false;
  return save.highestStageCleared >= FINALE_STAGE;
}
